// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mao_value span[data-v-40383fb5]{float:right}", "",{"version":3,"sources":["webpack://./resources/client/forms/NovationAnalysisForm.vue"],"names":[],"mappings":"AAIE,iCACE,WAHJ","sourcesContent":["\n@import \"../styles/variables/variables\";\n\n.mao_value {\n  span {\n    float: right;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
